import IconWrapper from './icon-wrapper';

const normalIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="3.5" stroke="#262626" stroke-width="2" />
    <path
      d="M10.5 2.86603C11.4282 2.33013 12.5718 2.33013 13.5 2.86603L19.1603 6.13397C20.0885 6.66987 20.6603 7.66025 20.6603 8.73205V15.2679C20.6603 16.3397 20.0885 17.3301 19.1603 17.866L13.5 21.134C12.5718 21.6699 11.4282 21.6699 10.5 21.134L4.83975 17.866C3.91154 17.3301 3.33975 16.3397 3.33975 15.2679V8.73205C3.33975 7.66025 3.91154 6.66987 4.83975 6.13397L10.5 2.86603Z"
      stroke="#262626"
      stroke-width="2"
    />
  </svg>
);

const activedIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5001 2.86604C11.4283 2.33014 12.5719 2.33014 13.5001 2.86603L19.1604 6.13398C20.0886 6.66988 20.6604 7.66026 20.6604 8.73206V15.268C20.6604 16.3398 20.0886 17.3301 19.1604 17.866L13.5001 21.134C12.5719 21.6699 11.4283 21.6699 10.5001 21.134L4.83984 17.866C3.91164 17.3301 3.33984 16.3398 3.33984 15.268V8.73206C3.33984 7.66026 3.91164 6.66988 4.83984 6.13398L10.5001 2.86604Z"
      fill="#262626"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0001 2.00001C11.2377 1.28548 12.7625 1.28548 14.0001 2.00001L19.6604 5.26796C20.898 5.98249 21.6604 7.303 21.6604 8.73206V15.268C21.6604 16.697 20.898 18.0175 19.6604 18.7321L14.0001 22C12.7625 22.7145 11.2377 22.7145 10.0001 22L4.33984 18.7321C3.10224 18.0175 2.33984 16.697 2.33984 15.268V8.73206C2.33984 7.303 3.10224 5.98249 4.33984 5.26796L10.0001 2.00001Z"
      fill="url(#paint0_linear_18903_5851)"
    />
    <circle cx="12" cy="12" r="3.5" stroke="white" stroke-width="2" />
    <defs>
      <linearGradient
        id="paint0_linear_18903_5851"
        x1="5.39045"
        y1="3.12501"
        x2="22.5373"
        y2="19.3799"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5891FF" />
        <stop offset="1" stop-color="#3768FA" />
      </linearGradient>
    </defs>
  </svg>
);

export default function IconSystem() {
  return <IconWrapper normalIcon={normalIcon} activedIcon={activedIcon} />;
}
